export enum massnahmenModel {
  SINGULAR = 'Maßnahme',
  PLURAL = 'Maßnahmen',
  ROUTE = '/massnahmen',
  ICON = 'mdi-bell-outline',
  ITEM_KEY = 'massnahme',
  ITEM_KEY_UPDATE = 'massnahmen',
  COMING_SOON = 'true'
}
